import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import palette, { status } from './palette';
import typography from './typography';
import shape from './shape';
import components from './components';
import { customSlider } from './customSlider';
import { StyledTableCell } from './styled/StyledTableCell';
import { StyledTableRow } from './styled/StyledTableRow';
import PrimaryButton from './styled/PrimaryButton';
import ProfitLossText from './styled/ProfitLossText';
import StyledPagination from './styled/StyledPagination';

export { colors, layout, shape as shapeTokens } from './tokens';
export { customSlider, StyledTableCell, StyledTableRow };
export { PrimaryButton, ProfitLossText, StyledPagination };

let defaultTheme = createTheme({
  typography,
  status,
  palette,
  shape,
  components,
});

defaultTheme = responsiveFontSizes(defaultTheme);

export default defaultTheme;

